import React, { useEffect } from 'react';

const BetaAccessDenied: React.FC = () => {
  useEffect(() => {
    // Redirect to /soft-launch after 5 seconds using window.location
      window.location.href = '/soft-launch';
  }, []);
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center p-4" style={
      {     background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)' }
      }>
   
    </div>
  );
};

export default BetaAccessDenied;
